import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { getDoctorStudyById } from 'src/services/api/api-client/StudyClient';
import { getDoctorStudyByIdQueryKey } from 'src/services/api/api-client/StudyQuery';
import { IDoctorProfileDto } from 'src/services/api/api-client';
import { StudyNotFoundError } from '../customErrors/customErrors';

export const studyQuery = (studyId: number) => ({
  queryKey: getDoctorStudyByIdQueryKey(studyId),
  queryFn: async () => getDoctorStudyById(studyId),
});

export const studyPageLoader =
  (queryClient: QueryClient, profile: IDoctorProfileDto) =>
  async ({ params }: LoaderFunctionArgs) => {
    const studyId = params.studyId;
    if (!studyId || Number.isNaN(studyId) || !profile.studies.includes(Number(studyId))) throw new StudyNotFoundError();

    const query = studyQuery(Number(studyId));
    return { study: await queryClient.fetchQuery(query) };
  };
